import React from 'react';
import Styles from './Divider.css';

export function Divider({ variant = 'default' }) {
  return (
    <>
      <hr className={`divider-widget ${variant}`} />
      <style jsx global>
        {Styles}
      </style>
    </>
  );
}
